import {
  addInteractions, beregnAreal, initUploadFunc, removeInteractions
} from './index';

export function initPanel() {

  var infoPanel = $.jsPanel({
    id: 'infoPanel',
    title: 'Kostra',
    resizable: {
      handles: 'se'
    },
    size: {
      width: window.innerWidth / 4,
      height: (window.innerHeight / 4) * 3
    },
    position: {
      left: 10,
      top: 10
    },
    // theme:    'light',
    overflow: 'auto',
    ajax: {
      url: 'panel.html?random='+ Math.random(),
      done: function( data, textStatus, jqXHR, panel ) {
        panelLoaded();
      }
    }
  });


  infoPanel.on('jspanelbeforeclose', function(){
     $('#open_info_button').show();
  });
}




function panelLoaded() {
   $('#open_info_button').hide();
  var isDrawing = false;
  $('#list').hide();

  $('#draw_button').click(function() {
    $('#draw_button').toggleClass("down");

    if (isDrawing) {
      isDrawing = false;
      removeInteractions();
    } else {
      isDrawing = true;
      addInteractions();
      $('#uploadPanel').hide();
    }
  });

  $('#upload_button').click(function() {
    $('#upload_button').toggleClass("down");
    $('#draw_button').removeClass("down");
    if ($('#uploadPanel').length === 0) {
      initUploadFunc();
    } else {
      $('#uploadPanel').remove();
    }

    // upload.initUpload();
    if (isDrawing) {
      isDrawing = false;
      removeInteractions();
    }
  });

  $('#beregn_button').click(function() {
    beregnAreal();
  });

  $('#help_button').click(function(event) {
    event.preventDefault();
		event.stopPropagation();
		window.open('https://www.nibio.no/tjenester/rapportering-i-kostra/bruk-av-kostra-applikasjonen', '_blank');
  });


  $('#back_button').click(function(event) {
    event.preventDefault();
    event.stopPropagation();
    var newWindow = window.open('', '_self', ''); //open the current window
    newWindow.close();
    //if (confirm("Denne nettleseren tillater ikke at denne fanen lukkes? Lukk det selv for å gå tilbake til Kilden")) {
      close();
    //}
  });


  $('#info_button').click(function(event) {
    event.preventDefault();
    event.stopPropagation();
    window.open('https://www.landbruksdirektoratet.no/nb/nyhetsrom/rapporter/kostra-landbruk', '_blank');
  });

}
